'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/21.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoadModal, _Component);

  function LoadModal() {
    (0, _classCallCheck3.default)(this, LoadModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LoadModal).call(this));
  }

  (0, _createClass3.default)(LoadModal, [{
    key: 'render',
    value: function render() {
      var styles = require('./LoadModal.scss');
      var imgSrc = require('./loadinging.gif');
      var isOpened = this.props.isOpened;

      var customStyle = {
        content: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: '55px',
          width: '55px',
          border: 'none',
          /*
           bottom: '40px',
           right: '40px',
           border: '1px solid #ccc',
           background: '#fff',
          borderRadius: '4px',
          overflow: 'auto',
           padding: '20px',*/
          outline: 'none',
          zIndex: 9999
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement('img', { className: styles.img, src: imgSrc })
      );
    }
  }]);
  return LoadModal;
}(_react.Component), _class.propTypes = {
  isOpened: _react.PropTypes.bool
}, _temp);
exports.default = LoadModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LoadModal/LoadModal.js
 ** module id = 1364
 ** module chunks = 0
 **/